// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Country$OrcaPaymentPage from "./Country.bs.js";

var countryDataRef = {
  contents: Country$OrcaPaymentPage.country
};

var stateDataRef = {
  contents: null
};

export {
  countryDataRef ,
  stateDataRef ,
}
/* No side effect */
